export { default } from './UnscoredCategoryPageButton'
